module.exports = __webpack_public_path__ + "img/blue1240x220.90df19a6.png";